import React, { useState, useRef, useEffect } from "react";
import {
    Modal,
    Input,
    Spin,
    Select,
    Form,
    message,
    Row,
    Col,
    Button,
} from "antd";
import { pickNotNumberAllowDecimal } from "$ACTIONS/reg";
import { formItemLayout } from "$ACTIONS/constantsData";
import { translate } from "$ACTIONS/Translate";
const { TextArea } = Input;
const { Option } = Select;
const { Item } = Form;

// 已申請資料Modal
// daily deal、Manual promotion(Physical)
export function AppliedDataModal(props) {
    const { isVisible, onCancel, appliedItem, title = "" } = props;
    const { bonusDailyDealsDetail } = appliedItem;
    console.log("appliedItem", appliedItem);

    return (
        <Modal
            width={400}
            title={title} //申请资料
            className="check-apply-data-container-modal-bonus-details physical promotion-modal"
            visible={isVisible}
            onCancel={onCancel}
            footer={null}
        >
            {appliedItem && (
                <>
                    <h3>{appliedItem.bonusName}</h3>
                    <label>{translate("奖励地址")}</label>
                    {/* 邮寄地址 */}
                    <div className="info">
                        <p className="name">
                            {bonusDailyDealsDetail.firstName}
                        </p>
                        <p className="phone">{`+ 84 ${bonusDailyDealsDetail.contactNumber}`}</p>
                        {/* 联系电话 */}
                        <p className="address">{`${bonusDailyDealsDetail.address} ${bonusDailyDealsDetail.area} ${bonusDailyDealsDetail.city}
                        ${bonusDailyDealsDetail.province} ${bonusDailyDealsDetail.zipCode}`}</p>
                        {/* 地址 */}
                    </div>
                    <label>{translate("备注")}</label>
                    <div className="remark">
                        <p>{bonusDailyDealsDetail.remark}</p>
                        {/* 留言 */}
                    </div>
                </>
            )}
        </Modal>
    );
}
